import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { BookingComponent } from './pages/booking/booking.component';
import { BookingDetailComponent } from './pages/booking/booking-detail.component';
import { BookingConfirmationComponent } from './pages/booking/booking-confirmation.component';
import { AdminDashboardComponent } from './pages/admin/admin-dashboard.component';
import { BookingEditComponent } from './pages/admin/booking-edit.component';
import { EquipmentEditComponent } from './pages/admin/equipment-edit.component';
import { SeoLandingpageComponent } from './pages/seo-landingpage/seo-landingpage.component';
import { ContactComponent } from './pages/contact/contact.component';
import { ImprintComponent } from './pages/imprint/imprint.component';
import { adminGuard } from './core/guards/admin.guard';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'mobile-videowall-leipzig-mieten',
    component: SeoLandingpageComponent
  },
  {
    path: 'booking',
    component: BookingComponent
  },
  {
    path: 'booking/confirmation',
    component: BookingConfirmationComponent
  },
  {
    path: 'booking/:id',
    component: BookingDetailComponent
  },
  {
    path: 'admin',
    component: AdminDashboardComponent,
    canActivate: [adminGuard]
  },
  {
    path: 'admin/booking/:id',
    component: BookingEditComponent,
    canActivate: [adminGuard]
  },
  {
    path: 'admin/equipment',
    component: EquipmentEditComponent,
    canActivate: [adminGuard]
  },
  {
    path: 'admin/equipment/:id',
    component: EquipmentEditComponent,
    canActivate: [adminGuard]
  },
  {
    path: 'kontakt',
    component: ContactComponent
  },
  {
    path: 'impressum',
    component: ImprintComponent
  },
  {
    path: '**',
    redirectTo: ''
  }
];
